import { render, staticRenderFns } from "./SectionText.vue?vue&type=template&id=2e5e137e&scoped=true&"
import script from "./SectionText.vue?vue&type=script&lang=ts&"
export * from "./SectionText.vue?vue&type=script&lang=ts&"
import style0 from "./SectionText.vue?vue&type=style&index=0&id=2e5e137e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5e137e",
  null
  
)

export default component.exports